import { dataGamepadSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGamepadSolid = /*#__PURE__*/createIcon(dataGamepadSolid)
export default IconGamepadSolid
